import PropTypes from 'prop-types';
import React from 'react';

const NodeInactive = ({ className }) => (
  <svg
    className={className}
    width="1731"
    height="857"
    viewBox="0 0 1731 857"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="1413" cy="389" r="72" fill="url(#paint0_linear_1112_10243)" />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="14"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="1382.33" y="350.9">
        MEMORY
      </tspan>
    </text>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="44"
      fontWeight="300"
      letterSpacing="0em"
    >
      <tspan x="1370.2" y="396.4">
        29%
      </tspan>
    </text>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="13"
      letterSpacing="0em"
    >
      <tspan x="1384.7" y="419.55">
        Address:&#10;
      </tspan>
      <tspan x="1381.12" y="435.55">
        0x4553e0
      </tspan>
    </text>
    <g filter="url(#filter0_ddd_1112_10243)">
      <rect x="600" y="304" width="696" height="430" rx="12" fill="white" />
    </g>
    <rect opacity="0.1" x="600" y="377" width="696" height="24" fill="#FD0054" />
    <rect opacity="0.1" x="649" y="341" width="1" height="393" fill="#181A1B" />
    <text
      opacity="0.6"
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="616.184" y="372.938">
        36&#10;
      </tspan>
      <tspan x="616.184" y="393.938">
        37&#10;
      </tspan>
      <tspan x="616.184" y="414.938">
        38&#10;
      </tspan>
      <tspan x="616.184" y="435.938">
        39&#10;
      </tspan>
      <tspan x="616.184" y="456.938">
        40&#10;
      </tspan>
      <tspan x="616.184" y="477.938">
        41&#10;
      </tspan>
      <tspan x="616.184" y="498.938">
        42&#10;
      </tspan>
      <tspan x="616.184" y="519.938">
        43&#10;
      </tspan>
      <tspan x="616.184" y="540.938">
        44&#10;
      </tspan>
      <tspan x="616.184" y="561.938">
        45&#10;
      </tspan>
      <tspan x="616.184" y="582.938">
        46&#10;
      </tspan>
      <tspan x="616.184" y="603.938">
        47&#10;
      </tspan>
      <tspan x="616.184" y="624.938">
        48&#10;
      </tspan>
      <tspan x="616.184" y="645.938">
        49&#10;
      </tspan>
      <tspan x="616.184" y="666.938">
        50&#10;
      </tspan>
      <tspan x="616.184" y="687.938">
        51&#10;
      </tspan>
      <tspan x="616.184" y="708.938">
        52
      </tspan>
    </text>
    <path
      d="M600 316C600 309.373 605.373 304 612 304H1284C1290.63 304 1296 309.373 1296 316V340H600V316Z"
      fill="white"
    />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="14"
      fontWeight="600"
      letterSpacing="0em"
    >
      <tspan x="922.243" y="326.9">
        Node.js
      </tspan>
    </text>
    <circle cx="622" cy="322" r="6" fill="#FD0054" />
    <circle cx="642" cy="322" r="6" fill="#FFB31A" />
    <circle cx="662" cy="322" r="6" fill="#00CC21" />
    <rect opacity="0.1" x="600" y="340" width="696" height="1" fill="#181A1B" />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="674" y="372.938">
        app.
      </tspan>
      <tspan x="732.857" y="372.938">
        (&apos;/search/:query?&apos;,{' '}
      </tspan>
      <tspan x="968.287" y="372.938">
        (req, res){'{'}&#10;
      </tspan>
      <tspan x="674" y="393.938">
        {' '}
      </tspan>
      <tspan x="716.041" y="393.938">
        {' '}
        query = req.
      </tspan>
      <tspan x="926.246" y="393.938">
        ;&#10;
      </tspan>
      <tspan x="674" y="414.938">
        {' '}
        db.
      </tspan>
      <tspan x="783.307" y="414.938">
        (query,{' '}
      </tspan>
      <tspan x="917.838" y="414.938">
        (err, vals){'{'}&#10;
      </tspan>
      <tspan x="674" y="435.938">
        {' '}
      </tspan>
      <tspan x="724.449" y="435.938">
        {' '}
        (err){' '}
      </tspan>
      <tspan x="833.756" y="435.938">
        {' '}
        res.
      </tspan>
      <tspan x="909.43" y="435.938">
        (
      </tspan>
      <tspan x="943.062" y="435.938">
        );&#10;
      </tspan>
      <tspan x="674" y="456.938">
        {' '}
        res.
      </tspan>
      <tspan x="774.898" y="456.938">
        (vals);&#10;
      </tspan>
      <tspan x="674" y="477.938">
        {' '}
        {'}'});&#10;
      </tspan>
      <tspan x="674" y="498.938">
        {'}'});&#10;
      </tspan>
      <tspan x="674" y="519.938" />
      <tspan x="674" y="540.938">
        app.
      </tspan>
      <tspan x="732.857" y="540.938">
        (&apos;/client.js&apos;,{' '}
      </tspan>
      <tspan x="926.246" y="540.938">
        (req, res){'{'}&#10;
      </tspan>
      <tspan x="674" y="561.938">
        {' '}
        res.
      </tspan>
      <tspan x="791.715" y="561.938">
        (path.
      </tspan>
      <tspan x="875.797" y="561.938">
        (__dirname, &apos;client.js&apos;));&#10;
      </tspan>
      <tspan x="674" y="582.938">
        {'}'});&#10;
      </tspan>
      <tspan x="674" y="603.938" />
      <tspan x="690.816" y="645.938">
        {' '}
        (!module.
      </tspan>
      <tspan x="825.348" y="645.938">
        ) {'{'}&#10;
      </tspan>
      <tspan x="674" y="666.938">
        {' '}
        app.
      </tspan>
      <tspan x="774.898" y="666.938">
        (
      </tspan>
      <tspan x="816.939" y="666.938">
        );&#10;
      </tspan>
      <tspan x="674" y="687.938">
        {' '}
        console.
      </tspan>
      <tspan x="783.307" y="687.938">
        (&apos;Express started on port 3000&apos;);&#10;
      </tspan>
      <tspan x="674" y="708.938">
        {'}'}
      </tspan>
    </text>
    <text
      fill="#8152E0"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="707.633" y="372.938">
        get
      </tspan>
      <tspan x="716.041" y="414.938">
        smembers
      </tspan>
      <tspan x="875.797" y="435.938">
        send
      </tspan>
      <tspan x="741.266" y="456.938">
        send
      </tspan>
      <tspan x="707.633" y="540.938">
        get
      </tspan>
      <tspan x="724.449" y="561.938">
        sendFile
      </tspan>
      <tspan x="842.164" y="561.938">
        join
      </tspan>
      <tspan x="724.449" y="666.938">
        listen
      </tspan>
      <tspan x="758.082" y="687.938">
        log
      </tspan>
    </text>
    <text
      fill="#00CCCC"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="825.348" y="393.938">
        params.query
      </tspan>
      <tspan x="917.838" y="435.938">
        500
      </tspan>
      <tspan x="774.898" y="645.938">
        parent
      </tspan>
      <tspan x="783.307" y="666.938">
        3000
      </tspan>
    </text>
    <text
      fill="#FD0054"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="901.021" y="372.938">
        function
      </tspan>
      <tspan x="690.816" y="393.938">
        var
      </tspan>
      <tspan x="850.572" y="414.938">
        function
      </tspan>
      <tspan x="707.633" y="435.938">
        if
      </tspan>
      <tspan x="783.307" y="435.938">
        return
      </tspan>
      <tspan x="858.98" y="540.938">
        function
      </tspan>
      <tspan x="674" y="645.938">
        if
      </tspan>
    </text>
    <text
      fill="#798486"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="674" y="624.938">
        /* istanbul ignore next */&#10;
      </tspan>
    </text>
    <g clipPath="url(#clip0_1112_10243)">
      <path
        d="M1261.59 690.778C1261.28 690.772 1260.97 690.846 1260.69 690.993L1252.07 695.874C1251.8 696.032 1251.57 696.257 1251.41 696.528C1251.26 696.799 1251.17 697.106 1251.18 697.418V707.161C1251.17 707.473 1251.26 707.779 1251.41 708.05C1251.57 708.321 1251.8 708.547 1252.07 708.705L1254.32 709.978C1255.42 710.507 1255.82 710.498 1256.32 710.498C1257.94 710.498 1258.86 709.535 1258.86 707.861V698.243C1258.86 698.211 1258.85 698.18 1258.84 698.151C1258.83 698.122 1258.81 698.096 1258.78 698.074C1258.76 698.052 1258.73 698.035 1258.7 698.024C1258.67 698.013 1258.64 698.008 1258.61 698.009H1257.53C1257.49 698.008 1257.46 698.013 1257.43 698.024C1257.4 698.035 1257.37 698.052 1257.35 698.073C1257.32 698.095 1257.3 698.121 1257.29 698.151C1257.28 698.18 1257.27 698.211 1257.27 698.243V707.862C1257.27 708.604 1256.48 709.35 1255.2 708.723L1252.86 707.377C1252.82 707.357 1252.78 707.327 1252.76 707.289C1252.73 707.251 1252.72 707.207 1252.71 707.162V697.418C1252.72 697.37 1252.73 697.324 1252.76 697.283C1252.78 697.243 1252.82 697.209 1252.86 697.185L1261.46 692.322C1261.5 692.3 1261.54 692.288 1261.59 692.288C1261.63 692.288 1261.68 692.3 1261.72 692.322L1270.32 697.184C1270.36 697.208 1270.4 697.242 1270.42 697.283C1270.45 697.323 1270.46 697.37 1270.47 697.418V707.161C1270.47 707.208 1270.45 707.253 1270.43 707.294C1270.41 707.335 1270.38 707.369 1270.34 707.394L1261.72 712.257C1261.68 712.278 1261.64 712.289 1261.59 712.289C1261.55 712.289 1261.5 712.278 1261.46 712.257L1259.25 710.966C1259.21 710.948 1259.18 710.938 1259.14 710.938C1259.1 710.938 1259.06 710.948 1259.03 710.966C1258.42 711.305 1258.3 711.344 1257.73 711.54C1257.59 711.588 1257.37 711.663 1257.8 711.899L1260.69 713.567C1260.97 713.72 1261.28 713.801 1261.59 713.801C1261.91 713.801 1262.21 713.72 1262.49 713.567L1271.11 708.704C1271.38 708.546 1271.61 708.32 1271.77 708.05C1271.92 707.779 1272 707.473 1272 707.161V697.418C1272 697.106 1271.92 696.799 1271.77 696.529C1271.61 696.258 1271.38 696.032 1271.11 695.874L1262.49 690.994C1262.21 690.846 1261.9 690.772 1261.59 690.778H1261.59Z"
        fill="#83CD29"
      />
      <path
        d="M1263.89 697.74C1261.44 697.74 1259.98 698.764 1259.98 700.468C1259.98 702.315 1261.43 702.823 1263.78 703.052C1266.6 703.322 1266.82 703.728 1266.82 704.269C1266.82 705.213 1266.05 705.615 1264.24 705.615C1261.96 705.615 1261.46 705.058 1261.29 703.947C1261.29 703.889 1261.26 703.835 1261.22 703.796C1261.17 703.756 1261.12 703.733 1261.06 703.731H1259.94C1259.87 703.733 1259.81 703.76 1259.76 703.807C1259.71 703.853 1259.68 703.917 1259.68 703.983C1259.68 705.405 1260.47 707.087 1264.24 707.087C1266.97 707.087 1268.54 706.035 1268.54 704.198C1268.54 702.374 1267.27 701.885 1264.62 701.541C1261.95 701.194 1261.7 701.024 1261.7 700.41C1261.7 699.904 1261.91 699.226 1263.89 699.226C1265.66 699.226 1266.31 699.6 1266.58 700.77C1266.59 700.824 1266.62 700.873 1266.67 700.909C1266.71 700.945 1266.76 700.965 1266.82 700.967H1267.94C1268.01 700.961 1268.07 700.929 1268.12 700.877C1268.14 700.854 1268.16 700.826 1268.18 700.795C1268.19 700.764 1268.19 700.731 1268.19 700.698C1268.02 698.684 1266.65 697.736 1263.89 697.736V697.74Z"
        fill="#83CD29"
      />
      <path
        d="M1210.92 678C1210.84 678 1210.77 678.013 1210.71 678.04C1210.64 678.067 1210.58 678.106 1210.53 678.156C1210.48 678.206 1210.43 678.266 1210.41 678.331C1210.38 678.397 1210.36 678.467 1210.36 678.538V692.268C1210.37 692.333 1210.35 692.397 1210.32 692.454C1210.29 692.511 1210.24 692.558 1210.18 692.591C1210.12 692.624 1210.06 692.642 1209.99 692.642C1209.92 692.642 1209.86 692.624 1209.8 692.591L1207.51 691.299C1207.34 691.204 1207.15 691.154 1206.96 691.154C1206.77 691.154 1206.58 691.204 1206.41 691.299L1197.28 696.466C1197.12 696.564 1196.98 696.703 1196.88 696.87C1196.78 697.037 1196.73 697.226 1196.73 697.417V707.754C1196.73 707.943 1196.78 708.129 1196.88 708.292C1196.98 708.456 1197.12 708.592 1197.28 708.686L1206.41 713.855C1206.58 713.95 1206.77 714 1206.96 714C1207.15 714 1207.34 713.95 1207.51 713.855L1216.64 708.686C1216.81 708.592 1216.95 708.456 1217.04 708.292C1217.14 708.129 1217.19 707.943 1217.19 707.754V681.986C1217.19 681.793 1217.14 681.603 1217.04 681.436C1216.94 681.269 1216.8 681.13 1216.63 681.035L1211.19 678.055C1211.11 678.013 1211.01 677.994 1210.92 678ZM1152.17 690.903C1152 690.904 1151.83 690.947 1151.68 691.028L1142.55 696.197C1142.38 696.291 1142.24 696.427 1142.15 696.591C1142.05 696.755 1142 696.941 1142 697.13L1142.02 711.002C1142.02 711.097 1142.04 711.19 1142.09 711.272C1142.14 711.354 1142.21 711.422 1142.29 711.468C1142.38 711.517 1142.47 711.543 1142.57 711.543C1142.66 711.543 1142.76 711.517 1142.84 711.468L1148.26 708.418C1148.43 708.324 1148.57 708.188 1148.67 708.025C1148.77 707.861 1148.82 707.675 1148.83 707.485V701.007C1148.83 700.818 1148.88 700.632 1148.97 700.468C1149.07 700.304 1149.21 700.168 1149.37 700.074L1151.68 698.764C1151.85 698.67 1152.04 698.62 1152.23 698.62C1152.42 698.62 1152.61 698.67 1152.78 698.764L1155.08 700.074C1155.25 700.168 1155.39 700.304 1155.49 700.468C1155.58 700.632 1155.63 700.818 1155.63 701.007V707.485C1155.64 707.675 1155.69 707.861 1155.79 708.024C1155.89 708.188 1156.03 708.324 1156.2 708.418L1161.62 711.469C1161.7 711.518 1161.8 711.544 1161.89 711.544C1161.99 711.544 1162.08 711.518 1162.17 711.469C1162.25 711.422 1162.32 711.354 1162.37 711.272C1162.42 711.19 1162.44 711.097 1162.44 711.002L1162.46 697.13C1162.46 696.941 1162.41 696.755 1162.31 696.591C1162.22 696.427 1162.08 696.291 1161.91 696.197L1152.78 691.028C1152.63 690.946 1152.46 690.903 1152.28 690.903H1152.17ZM1234.23 691.028C1234.04 691.028 1233.85 691.078 1233.68 691.172L1224.55 696.34C1224.38 696.435 1224.24 696.571 1224.15 696.735C1224.05 696.898 1224 697.084 1224 697.273V707.61C1224 707.8 1224.06 707.987 1224.15 708.151C1224.25 708.315 1224.39 708.45 1224.56 708.543L1233.62 713.604C1233.79 713.697 1233.97 713.748 1234.16 713.752C1234.35 713.755 1234.54 713.71 1234.7 713.621L1240.19 710.625C1240.28 710.579 1240.35 710.512 1240.4 710.43C1240.46 710.348 1240.48 710.254 1240.49 710.158C1240.49 710.063 1240.46 709.97 1240.41 709.888C1240.37 709.806 1240.3 709.738 1240.21 709.691L1231.03 704.523C1230.94 704.474 1230.87 704.403 1230.82 704.318C1230.76 704.233 1230.74 704.137 1230.73 704.038V700.809C1230.74 700.713 1230.77 700.619 1230.82 700.537C1230.87 700.455 1230.94 700.388 1231.03 700.342L1233.88 698.727C1233.96 698.679 1234.06 698.654 1234.16 698.654C1234.25 698.654 1234.35 698.679 1234.43 698.727L1237.29 700.342C1237.37 700.389 1237.44 700.457 1237.49 700.539C1237.53 700.621 1237.56 700.714 1237.56 700.809V703.355C1237.56 703.45 1237.59 703.543 1237.63 703.624C1237.68 703.706 1237.75 703.774 1237.83 703.821C1237.92 703.868 1238.01 703.893 1238.11 703.893C1238.21 703.893 1238.3 703.869 1238.38 703.821L1243.85 700.7C1244.02 700.605 1244.16 700.47 1244.26 700.306C1244.35 700.143 1244.41 699.957 1244.41 699.768V697.274C1244.41 697.085 1244.36 696.899 1244.26 696.735C1244.16 696.571 1244.02 696.435 1243.86 696.34L1234.78 691.172C1234.61 691.077 1234.42 691.028 1234.23 691.029L1234.23 691.028ZM1206.93 698.745C1206.98 698.745 1207.03 698.757 1207.07 698.781L1210.2 700.557C1210.25 700.58 1210.28 700.614 1210.31 700.655C1210.33 700.696 1210.35 700.742 1210.35 700.79V704.343C1210.35 704.392 1210.33 704.438 1210.31 704.479C1210.28 704.52 1210.25 704.554 1210.2 704.577L1207.07 706.354C1207.03 706.377 1206.98 706.389 1206.94 706.389C1206.89 706.389 1206.84 706.377 1206.8 706.354L1203.67 704.577C1203.63 704.554 1203.59 704.52 1203.56 704.479C1203.54 704.438 1203.52 704.391 1203.52 704.343V700.79C1203.53 700.742 1203.54 700.696 1203.56 700.655C1203.59 700.614 1203.63 700.58 1203.67 700.557L1206.8 698.781C1206.84 698.757 1206.88 698.745 1206.93 698.745V698.745Z"
        fill="#404137"
      />
      <path
        d="M1179.6 690.975C1179.41 690.974 1179.22 691.024 1179.06 691.119L1169.92 696.269C1169.76 696.367 1169.62 696.507 1169.52 696.673C1169.42 696.84 1169.37 697.029 1169.38 697.22V707.556C1169.37 707.746 1169.43 707.931 1169.52 708.095C1169.62 708.259 1169.76 708.395 1169.92 708.49L1179.06 713.658C1179.22 713.753 1179.41 713.803 1179.6 713.803C1179.8 713.803 1179.99 713.753 1180.15 713.658L1189.28 708.49C1189.45 708.395 1189.59 708.259 1189.69 708.095C1189.78 707.931 1189.83 707.746 1189.83 707.556V697.22C1189.83 697.028 1189.78 696.84 1189.69 696.673C1189.59 696.506 1189.45 696.367 1189.28 696.269L1180.15 691.121C1179.99 691.026 1179.8 690.976 1179.6 690.977V690.975ZM1234.21 700.2C1234.17 700.197 1234.14 700.203 1234.1 700.218L1232.34 701.223C1232.31 701.241 1232.28 701.267 1232.26 701.298C1232.25 701.33 1232.24 701.366 1232.23 701.402V703.376C1232.24 703.413 1232.25 703.449 1232.26 703.48C1232.28 703.512 1232.31 703.538 1232.34 703.556L1234.1 704.543C1234.13 704.561 1234.17 704.571 1234.2 704.571C1234.24 704.571 1234.27 704.561 1234.3 704.543L1236.06 703.555C1236.09 703.537 1236.12 703.511 1236.14 703.48C1236.16 703.449 1236.17 703.413 1236.17 703.376V701.401C1236.17 701.365 1236.16 701.329 1236.14 701.297C1236.12 701.266 1236.09 701.24 1236.06 701.222L1234.3 700.217C1234.27 700.201 1234.24 700.195 1234.21 700.199L1234.21 700.2Z"
        fill="#83CD29"
      />
    </g>
    <path
      d="M1303 389H1333"
      stroke="#AFB5B6"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="0.01 10"
    />
    <defs>
      <filter
        id="filter0_ddd_1112_10243"
        x="560"
        y="284"
        width="776"
        height="510"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1112_10243" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1112_10243"
          result="effect2_dropShadow_1112_10243"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="20" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1112_10243"
          result="effect3_dropShadow_1112_10243"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1112_10243"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1112_10243"
        x1="1485"
        y1="317"
        x2="1341"
        y2="461"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCFDFD" />
        <stop offset="1" stopColor="#F4F5F6" />
      </linearGradient>
      <clipPath id="clip0_1112_10243">
        <rect width="130" height="36" fill="white" transform="translate(1142 678)" />
      </clipPath>
    </defs>
  </svg>
);

NodeInactive.propTypes = {
  className: PropTypes.string,
};

NodeInactive.defaultProps = {
  className: null,
};

export default NodeInactive;
